import React, { useState } from "react";
import Results from "./Results";
import Photos from "./Photos";
import "./Dictionary.css";
import axios from "axios";


export default function Dictionary() {
    let [searchword, setSearchword] = useState("sunset");
    let [results, setResults] = useState(null);
    let [loaded, setLoaded] = useState(false);
    let [photos, setPhotos] = useState(null)

    function handleResponse(response){
        setResults(response.data);
    }

    function handlePhotoResponse(response) {
        setPhotos(response.data.photos);
    }
    function search() {
        let apiKey = `d102f34aao5ce8t34e64ea7aab7a37d2`
        let apiUrl = `https://api.shecodes.io/dictionary/v1/define?word=${searchword}&key=${apiKey}`
        axios.get(apiUrl).then(handleResponse);

        let photoApiKey = `d102f34aao5ce8t34e64ea7aab7a37d2`
        let photoApiUrl = `https://api.shecodes.io/images/v1/search?query=${searchword}&key=${photoApiKey}`
        axios.get(photoApiUrl).then(handlePhotoResponse);
    }

    function handleSubmit(event) {
        event.preventDefault();
        search();
    }

    function handleSearchwordChange(event) {
        setSearchword(event.target.value)
    }

    function load(){
        setLoaded(true);
        search();
    }

    if (loaded) {
          return <div className="Dictionary">
            <form onSubmit={handleSubmit}>
                <input className="form-control" type="search" onChange={handleSearchwordChange} placeholder="Search for a word"/>
            </form>
        <Results results={results}/>
        <Photos photos={photos} />
           </div>;
    } else {
        load();
        return null;
    }
}